import { render, staticRenderFns } from "./HorizontalCard.vue?vue&type=template&id=277d6737&scoped=true"
import script from "./HorizontalCard.vue?vue&type=script&lang=js"
export * from "./HorizontalCard.vue?vue&type=script&lang=js"
import style0 from "./HorizontalCard.vue?vue&type=style&index=0&id=277d6737&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277d6737",
  null
  
)

export default component.exports